import React from 'react'
import { useIntl } from 'react-intl'
import { useData } from 'vike-react/useData'

import { helpArticlePathParams } from '../../../data/helpCenterFormat'
import { useRoutes } from '../../../routes'
import { HelpDoc } from '../HelpDoc'
import { HelpShell } from '../HelpShell'
import { HELP_CONTENT_WIDTH } from '../helpTheme'
import type { Data } from './+data'

export default function HelpArticlePage() {
  const data = useData<Data>()
  const intl = useIntl()
  const routes = useRoutes()

  return (
    <HelpShell
      nav={{
        root: data.root,
        categories: data.categories,
        currentNoteId: data.currentNoteId,
        expandedIds: data.expandedIds,
      }}
      toc={data.headings}
      contentWidth={HELP_CONTENT_WIDTH}
      title={intl.formatMessage(
        {
          id: 'website.helpCenter.article.helmet.title',
          defaultMessage: '{title} | Slite Help Center',
        },
        { title: data.note.title }
      )}
      description={intl.formatMessage(
        {
          id: 'website.helpCenter.article.helmet.description',
          defaultMessage: '{title} — guides and answers from the Slite team.',
        },
        { title: data.note.title }
      )}
      canonicalUrl={routes.helpCenter.article(helpArticlePathParams(data.note))}
    >
      <HelpDoc
        title={data.note.title}
        html={data.note.html}
        iconShape={data.note.iconShape}
        iconColor={data.note.iconColor}
      />
    </HelpShell>
  )
}
